var render = function render(){var _vm=this,_c=_vm._self._c;return _c('modal',{attrs:{"back":"edit-text","title":_vm.$t('customization.changeColor')}},[_c('color-picker',{attrs:{"colors":_vm.colors,"selected-color":_vm.element.effectColor,"with-color-wheel":_vm.withColorWheel},on:{"selectColor":function($event){return _vm.selectColor($event)},"close":_vm.closeModal}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }